import { createReducer } from 'typesafe-actions'
import { GetCrmRulesResponseDto, ICrmRules } from '@sparling/financial-common'
import { ActionTypes } from '../types'
import { LoadingStateEnum } from '../../types'
import {
  getRiskScoreRulesRequest,
  getRiskScoreRulesSuccess,
  getRiskScoreRulesFailure,
  getRiskScoreRuleRequest,
  getRiskScoreRuleSuccess,
  getRiskScoreRuleFailure,
  createRiskScoreRuleRequest,
  createRiskScoreRuleSuccess,
  createRiskScoreRuleFailure,
  updateRiskScoreRuleRequest,
  updateRiskScoreRuleSuccess,
  updateRiskScoreRuleFailure,
  deleteRiskScoreRuleRequest,
  deleteRiskScoreRuleSuccess,
  deleteRiskScoreRuleFailure,
} from '../actions'

export interface CrmRulesState {
  list: {
    loading: LoadingStateEnum
    data: GetCrmRulesResponseDto
    error: Error | null
  }
  details: {
    loading: LoadingStateEnum
    data: ICrmRules | null
    error: Error | null
  }
}

export const initialState: CrmRulesState = {
  list: {
    loading: LoadingStateEnum.IDLE,
    data: {
      items: [],
      meta: {
        itemCount: 0,
        totalItems: 0,
        itemsPerPage: 10,
        totalPages: 0,
        currentPage: 1,
      },
    },
    error: null,
  },
  details: {
    loading: LoadingStateEnum.IDLE,
    data: null,
    error: null,
  },
}

export const crmRulesReducer = createReducer<CrmRulesState, ActionTypes>(initialState)
  // Get List
  .handleAction(getRiskScoreRulesRequest, (state) => ({
    ...state,
    list: { ...state.list, loading: LoadingStateEnum.LOADING },
  }))
  .handleAction(getRiskScoreRulesSuccess, (state, { payload }) => ({
    ...state,
    list: { ...state.list, loading: LoadingStateEnum.SUCCESS, data: payload },
  }))
  .handleAction(getRiskScoreRulesFailure, (state, { payload }) => ({
    ...state,
    list: { ...state.list, loading: LoadingStateEnum.ERROR, error: payload },
  }))

  // Get Single
  .handleAction(getRiskScoreRuleRequest, (state) => ({
    ...state,
    details: { ...state.details, loading: LoadingStateEnum.LOADING },
  }))
  .handleAction(getRiskScoreRuleSuccess, (state, { payload }) => ({
    ...state,
    details: { ...state.details, loading: LoadingStateEnum.SUCCESS, data: payload.data },
  }))
  .handleAction(getRiskScoreRuleFailure, (state, { payload }) => ({
    ...state,
    details: { ...state.details, loading: LoadingStateEnum.ERROR, error: payload },
  }))

  // Create
  .handleAction(createRiskScoreRuleRequest, (state) => ({
    ...state,
    details: { ...state.details, loading: LoadingStateEnum.LOADING },
  }))
  .handleAction(createRiskScoreRuleSuccess, (state, { payload }) => ({
    ...state,
    details: { ...state.details, loading: LoadingStateEnum.SUCCESS, data: payload.data },
  }))
  .handleAction(createRiskScoreRuleFailure, (state, { payload }) => ({
    ...state,
    details: { ...state.details, loading: LoadingStateEnum.ERROR, error: payload },
  }))

  // Update
  .handleAction(updateRiskScoreRuleRequest, (state) => ({
    ...state,
    details: { ...state.details, loading: LoadingStateEnum.LOADING },
  }))
  .handleAction(updateRiskScoreRuleSuccess, (state, { payload }) => ({
    ...state,
    details: { ...state.details, loading: LoadingStateEnum.SUCCESS, data: payload.data },
  }))
  .handleAction(updateRiskScoreRuleFailure, (state, { payload }) => ({
    ...state,
    details: { ...state.details, loading: LoadingStateEnum.ERROR, error: payload },
  }))

  // Delete
  .handleAction(deleteRiskScoreRuleRequest, (state) => ({
    ...state,
    list: {
      ...state.list,
      loading: LoadingStateEnum.LOADING,
      error: null,
    },
  }))
  .handleAction(deleteRiskScoreRuleSuccess, (state) => ({
    ...state,
    list: {
      ...state.list,
      loading: LoadingStateEnum.SUCCESS,
    },
  }))
  .handleAction(deleteRiskScoreRuleFailure, (state, { payload }) => ({
    ...state,
    list: {
      ...state.list,
      loading: LoadingStateEnum.ERROR,
      error: payload,
    },
  }))
